import { withTheme } from "styled-components";
import DefaultTable, {
  ActionButtons,
  Line,
} from "../../ui-library/CustomTable/DefaultTable";
import React from "react";
import { Dropdown } from "react-bootstrap";
import TableDropDown from "../../ui-library/TableDropDown/TableDropDown";
import CustomChip from "../../ui-library/CustomChip/CustomChip";
import ButtonDropdown from "../../ui-library/ButtonDropdown/ButtonDropdown";
import { useTranslation } from "react-i18next";
import {
  decimalPlaces,
  roundMealPercentage,
  roundMealValue,
} from "../../../helpers/mealsHelper";
import { UNIT } from "../../../modules/constants";
import { isRtl } from "../../../i18n/helpers";

const FavoritesTable = (props) => {
  const {
    getData,
    searchedParams,
    totalitems,
    favorites,
    canEditFavorites,
    canViewDetailFavorites,
    canCreateFavorites,
    onEdit,
    onView,
    loading,
    dietDiaryOptions,
    canRemoveFavorites,
    onDelete,
  } = props;

  const { t } = useTranslation();

  const defaultProps = {
    headers: [
      { label: t("appText.name") },
      { label: t("appText.description") },
      { label: t("appText.dietDiary.calories") },
      {
        label: isRtl()
          ? t("appText.dietDiary.mediumChainFats")
          : t("appText.dietDiary.mcf"),
      },
      {
        label: isRtl()
          ? t("appText.dietDiary.longChainFats")
          : t("appText.dietDiary.lcf"),
      },
      { label: t("appText.dietDiary.protein") },
      { label: t("appText.dietDiary.carbohydrates") },
      { label: t("appText.options") },
    ],
    hasSearch: false,
    haspagesizefilter: true,
    haspagination: true,
    searchedParams,
    totalitems,
    loading,
    getData,
  };

  const getDropDownItems = (favoriteEntry) => {
    const dropDownMenuItems = {
      EDIT: {
        text: t("appText.edit"),
        callBack: (favorite) => onEdit(favorite),
        id: 1,
        isVisible: canEditFavorites,
        isDisabled: !favoriteEntry.isOriginator,
      },
      VIEW_DETAILS: {
        text: t("appText.viewDetails"),
        callBack: (favorite) => onView(favorite),
        id: 2,
        isVisible: canViewDetailFavorites,
      },
      REMOVE: {
        text: t("appText.favorites.remove"),
        callBack: (favorite) => onDelete(favorite),
        id: 3,
        isVisible: canRemoveFavorites,
        isDisabled: !favoriteEntry.isOriginator,
      },
    };

    return Object.values(dropDownMenuItems);
  };

  return (
    <DefaultTable {...defaultProps} isRtl={isRtl()} fixedLayout>
      <ActionButtons>
        {canCreateFavorites && dietDiaryOptions && (
          <ButtonDropdown
            size="sm"
            title={t("appText.addNew")}
            options={Object.values(dietDiaryOptions).sort(
              (a, b) => a.order < b.order
            )}
            align={isRtl() ? "end" : "start"}
          />
        )}
      </ActionButtons>
      {favorites?.map((favorite, index) => (
        <Line key={`${favorite.favoriteId}-${index}`}>
          <CustomChip text={favorite.name} tooltipPlacement="bottom" />
          <span>{favorite.description}</span>
          <span>{`${Number(
            roundMealValue(favorite.calories?.value || 0)
          ).toFixed(decimalPlaces)}${favorite.calories.unit}`}</span>
          <span>{`${Number(
            roundMealPercentage(
              roundMealValue(favorite.mediumChainFats?.percentage || 0)
            )
          ).toFixed(decimalPlaces)}${UNIT.PERCENTAGE}
            - ${Number(
              roundMealValue(favorite.mediumChainFats?.value || 0)
            ).toFixed(decimalPlaces)}${
            favorite.mediumChainFats?.unit || UNIT.DEFAULT
          }`}</span>
          <span>{`${Number(
            roundMealPercentage(
              roundMealValue(favorite.longChainFats?.percentage || 0)
            )
          ).toFixed(decimalPlaces)}${UNIT.PERCENTAGE} - ${Number(
            roundMealValue(favorite.longChainFats?.value || 0)
          ).toFixed(decimalPlaces)}${
            favorite.longChainFats?.unit || UNIT.DEFAULT
          }`}</span>
          <span>{`${Number(
            roundMealPercentage(
              roundMealValue(favorite.protein?.percentage || 0)
            )
          ).toFixed(decimalPlaces)}${UNIT.PERCENTAGE} - ${Number(
            roundMealValue(favorite.protein?.value || 0)
          ).toFixed(decimalPlaces)}${
            favorite.protein?.unit || UNIT.DEFAULT
          }`}</span>
          <span>{`${Number(
            roundMealPercentage(
              roundMealValue(favorite.carbohydrates?.percentage || 0)
            )
          ).toFixed(decimalPlaces)}${UNIT.PERCENTAGE} - ${Number(
            roundMealValue(favorite.carbohydrates?.value || 0)
          ).toFixed(decimalPlaces)}${
            favorite.carbohydrates?.unit || UNIT.DEFAULT
          }`}</span>
          <TableDropDown isRtl={isRtl()}>
            {getDropDownItems(favorite)
              .filter((dropDownItem) => dropDownItem.isVisible)
              .map((item, index) => (
                <Dropdown.Item
                  key={index}
                  bsPrefix="dropdown-item"
                  disabled={item.isDisabled}
                  onClick={() => item.callBack(favorite)}
                >
                  {item.text}
                </Dropdown.Item>
              ))}
          </TableDropDown>
        </Line>
      ))}
    </DefaultTable>
  );
};

export default withTheme(FavoritesTable);
